/**
 * Product page behaviour: analytics events, quantity steppers, variant
 * selection and the thumbnail gallery.
 *
 * Requires the `strichwerke` namespace from global.js.
 */

strichwerke.Analytics = {
  track: function (eventName, parameters) {
    const eventPayload = {
      currency: parameters.currency || window.Shopify?.currency?.active,
      value: parameters.value,
      items: parameters.items || [],
      ...parameters,
    };

    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, eventPayload);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: eventName, ecommerce: eventPayload });
    }
  },

  productItem: function (product, variantId, quantity) {
    return {
      item_id: String(product.id),
      item_name: product.title,
      item_brand: product.vendor,
      item_category: product.type,
      item_variant: String(variantId || product.variantId),
      price: Number(product.price),
      quantity: quantity || 1,
      item_list_name: product.collection || undefined,
    };
  },
};

strichwerke.Product = {
  init: function () {
    this.setupQuantityInputs();
    this.setupVariantSelects();
    this.trackProductView();
  },

  trackProductView: function () {
    const productData = document.querySelector("[data-product-analytics]");
    if (!productData) return;

    const product = JSON.parse(productData.textContent);
    const item = strichwerke.Analytics.productItem(product, product.variantId, 1);
    item.price = Number(product.priceCents || 0) / 100;
    strichwerke.Analytics.track("view_item", {
      currency: product.currency,
      value: item.price,
      items: [item],
    });
  },

  trackCheckoutStart: function (form) {
    const checkoutButton = form.querySelector('[name="checkout"]');
    if (!checkoutButton) return;

    form.addEventListener("submit", function (event) {
      if (event.submitter && event.submitter.name !== "checkout") return;

      const cartData = document.querySelector("[data-cart-analytics]");
      if (!cartData) return;

      const cart = JSON.parse(cartData.textContent);
      strichwerke.Analytics.track("begin_checkout", {
        currency: cart.currency,
        value: Number(cart.value),
        items: cart.items,
      });
    });
  },

  setupQuantityInputs: function () {
    const quantityWrappers = document.querySelectorAll("[data-quantity]");
    quantityWrappers.forEach((wrapper) => {
      const input = wrapper.querySelector('input[type="number"]');
      const decrease = wrapper.querySelector("[data-decrease]");
      const increase = wrapper.querySelector("[data-increase]");

      if (decrease) {
        decrease.addEventListener("click", () => {
          const current = parseInt(input.value, 10);
          if (current > 1) {
            input.value = current - 1;
            input.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });
      }

      if (increase) {
        increase.addEventListener("click", () => {
          const current = parseInt(input.value, 10);
          input.value = current + 1;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }
    });
  },

  setupVariantSelects: function () {
    const forms = document.querySelectorAll("form[data-product-form]");
    forms.forEach((form) => {
      const variantSelect = form.querySelector('[name="id"]');
      const priceDisplay = form.querySelector("[data-price]");
      const compareDisplay = form.querySelector("[data-compare-price]");

      if (variantSelect) {
        variantSelect.addEventListener("change", function () {
          const selectedOption = this.options[this.selectedIndex];
          const analyticsData = form
            .closest("[data-product-page]")
            ?.querySelector("[data-product-analytics]");
          if (analyticsData) {
            const product = JSON.parse(analyticsData.textContent);
            product.variantId = this.value;
            product.priceCents = Number(selectedOption.dataset.priceCents || 0);
            product.price = product.priceCents / 100;
            analyticsData.textContent = JSON.stringify(product);
          }
          if (selectedOption.dataset.price && priceDisplay) {
            priceDisplay.textContent = selectedOption.dataset.price;
          }
          if (selectedOption.dataset.comparePrice && compareDisplay) {
            compareDisplay.textContent = selectedOption.dataset.comparePrice;
            compareDisplay.style.display = selectedOption.dataset.comparePrice
              ? "inline"
              : "none";
          }
        });
      }
    });
  },
};

/* Thumbnail gallery: swap the main image when a thumbnail is clicked. */
document.addEventListener("DOMContentLoaded", () => {
  const thumbs = document.getElementsByClassName("thumbnail-btn");
  for (const thumb of thumbs) {
    thumb.addEventListener("click", (ev) => {
      document
        .querySelector(".thumbnail-btn.active")
        .classList.remove("active");
      thumb.classList.add("active");
      const mainImage = document.querySelector("#main-image");
      if (!mainImage) return;

      const fullSrc = thumb.dataset.fullSrc;
      const fullSrcset = thumb.dataset.fullSrcset;

      if (fullSrc) {
        mainImage.src = fullSrc;
      }
      if (fullSrcset) {
        mainImage.srcset = fullSrcset;
      } else {
        mainImage.removeAttribute("srcset");
      }
    });
  }
});
